import { number, object } from 'yup';

export default object().shape({
  numero_guiche: number().required('Este campo é obrigatório!'),
})